import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
  SVGIcon,
  Button,
  Tab as TabComponent,
  TabList as TabListComponent,
  TabPanels as TabPanelsComponent,
} from '@pearsontechnology/aero-components';

const HelpButtonElement = styled(Button)`
  position: fixed;
  bottom: 14px;
  right: 14px;
  z-index: 50;
  text-transform: capitalize;
  padding: 0 8px 0 15px;
  background: ${(props) => props.theme['color.blueGreyLighter']};
  transition: box-shadow 0.3s ease, background 0.3s ease;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  right: 10px;
  top: 12px;
`;

export const HelpButton = forwardRef((props, ref) => (
  <HelpButtonElement primary rounded ref={ref} height={32} {...props}>
    Help
    <SVGIcon icon="help" size={{ width: '20', height: '20' }} />
  </HelpButtonElement>
));

export const PanelContainer = styled.div`
  position: relative;
  justify-items: ${(props) => props.alignRight ? 'flex-end' : 'flex-start'};
  pointer-events: none;
  display: flex;
  flex-direction: column-reverse;

  > * {
    pointer-events: auto;
  }
`;

export const Tab = styled(TabComponent)`
  margin: 15px 9px 0 0;
`;

export const TabList = styled(TabListComponent)`
  padding: 0px 20px;
  height: 60px;
`;

export const TabPanels = styled(TabPanelsComponent)`
  height: calc(100vh - 60px);
  overflow-y: scroll;
  scrollbar-width: none; /** HIDES SCROLLBAR FROM FIREFOX */

  /** HIDES SCROLLBAR FROM EDGE/CHROME/SAFARI */
  ::-webkit-scrollbar {
      width: 0px;
      background: red; /* make scrollbar transparent */
  }
`;

export const HorizontalSeparator = styled.div`
  width: 100%;
  height: 1px;
  margin-top: -1px;
  box-shadow: 0 1px 1px 0 ${(props) => props.theme.themeId === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.12)'};
  z-index: 1;
`;
